import $api from 'http'

export async function getTestData(data) {
  return $api.get(`/worktests/`, data)
}
export async function getTestUser(id, data) {
  return $api.get(`/startworktests/${id}/`, data)
}
export async function getTestAllUser(id, formData) {
  return $api.patch(`/startworktestsall/${id}/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function GetURLTest(id) {
  return $api.post(`/geturltest/${id}/`)
}
export async function StartTestUser(id) {
  return $api.post(`/startworktests/${id}/`, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function StartTestAllUser(id, formdata) {
  return $api.post(`/startworktestsall/${id}/`, formdata,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function getTestUserData(data) {
  return $api.get(`/worktestsuser/`, data)
}



export async function getTestUserAllDetailData(id, data) {
  return $api.get(`/worktestsalluser/${id}/`, data)
}
export async function getTestUserAll(data) {
  return $api.get(`/worktestsuserall/`, data)
}
export async function PostTest(formdata) {
  return $api.post(`/worktests/`, formdata ,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function getTestDetailData(id, data) {
  return $api.get(`/worktest/${id}/`, data)
}

export async function getTestUserDetailData(id, data) {
  return $api.get(`/worktestsuser/${id}/`, data)
}


export async function OnOffTestDetailData(id,) {
  return $api.post(`/worktestonoff/${id}/`, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function updateTestDetailData(id, formdata) {
  return $api.post(`/worktest/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function PostPartWorkTest(id, formdata) {
  return $api.post(`/worktestdetail/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function PatchPartWorkTestAnswer(id, formdata) {
  return $api.post(`/worktestdetailanswer/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export async function removeAnswer(id,) {
  return $api.post(`/removeanswer/${id}/`, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function moveAnswerUp(id,) {
  return $api.post(`/moveanswerup/${id}/`, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function moveAnswerDown(id,) {
  return $api.post(`/moveanswerdown/${id}/`, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}




export async function ChangeAnswer(id,  formdata) {
  return $api.post(`/changeanswer/${id}/`,  formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function ChangeAnswerAll(id,  formdata) {
  return $api.post(`/changeanswerall/${id}/`,  formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}
export async function updatePointsPart(id,  formdata) {
  return $api.post(`/changeuserpart/${id}/`,  formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}